import {Directive, Inject, Input, Optional, SkipSelf} from '@angular/core';
import {ControlContainer, NG_VALIDATORS, Validator} from '@angular/forms';
import {takeUntil} from 'rxjs/operators';
import {VALIDATION_CONTEXTS, ValidationContext} from '../../data/validation-context';
import {VALIDATION_SKIP_DEFAULT_RULES, ValidationItemBaseDirective} from './validation-item-base.directive';

@Directive({
    // tslint:disable-next-line:directive-selector
    selector: '[ngModel][name]:not([formControlName]):not([formControl])',
    exportAs: 'validationItem',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: ValidationModelDirective,
            multi: true,
        }
    ]
})
export class ValidationModelDirective extends ValidationItemBaseDirective implements Validator {
    protected validatorChangeFn: () => void;

    public constructor(
        @Inject(VALIDATION_CONTEXTS) @SkipSelf()
            $validationContexts: Array<ValidationContext>,
        @Inject(VALIDATION_SKIP_DEFAULT_RULES) @SkipSelf() @Optional()
        protected readonly defaultSkipRules?: Array<string>,
        @Optional()
            $controlContainer?: ControlContainer,
    ) {
        super($validationContexts, $controlContainer);

        // Update value and validity each time validation rules are changed.
        this.rules$
            .pipe(
                takeUntil(this.us$)
            )
            .subscribe(() => {
                if (this.validatorChangeFn) {
                    this.validatorChangeFn();
                }
            });
    }

    protected constructUnexpectedWarn(): string {
        return `Unexpected empty rule on field: ${this.name}.`;
    }

    public registerOnValidatorChange($fn: () => void): void {
        this.validatorChangeFn = $fn;
    }

    @Input()
    public set name($value: string) {
        this.name$.next($value);
    }

    public get name(): string {
        return this.name$.value;
    }

    @Input()
    public set skipRules($value: Array<string>) {
        this.skipRules$.next(
            typeof $value === 'object' && Array.isArray($value)
                ? $value
                : this.defaultSkipRules
        );
    }

    public get skipRules(): Array<string> {
        return this.skipRules$.value;
    }

    @Input()
    public set skipValidation($value: boolean) {
        this.skipValidation$.next($value);
    }

    public get skipValidation(): boolean {
        return this.skipValidation$.value;
    }
}
